import React, { useEffect, useRef, useState } from 'react';

import { MdClose } from 'react-icons/md';
import Portal from '../Portal';
import { Header, IconButton, Title, Container, Overlay } from './styles';
import useModalOverlayLock from '@src/hooks/useModalOverlayLock';

type DrawerProps = {
  open: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  title?: string;
  showCloseButton?: boolean;
};

export const Drawer = (props: DrawerProps) => {
  const { open, onClose, children, title, showCloseButton = true } = props;

  useModalOverlayLock(open);

  const [contentHeight, setContentHeight] = useState(0);

  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setContentHeight(contentRef.current?.scrollHeight || 0);
  }, [children]);

  return (
    <>
      {open ? (
        <Portal>
          <Overlay className='planne-widget-drawer' onClick={onClose}>
            <Container open={open} contentHeight={contentHeight} ref={contentRef}>
              <Header>
                <Title>{title}</Title>
                {showCloseButton ? (
                  <IconButton onClick={onClose}>
                    <MdClose size={24} />
                  </IconButton>
                ) : null}
              </Header>

              {children}
            </Container>
          </Overlay>
        </Portal>
      ) : null}
    </>
  );
};

export default Drawer;
